import { render, staticRenderFns } from "./paperSheet.vue?vue&type=template&id=e12090d6&scoped=true"
import script from "./paperSheet.vue?vue&type=script&lang=js"
export * from "./paperSheet.vue?vue&type=script&lang=js"
import style0 from "./paperSheet.vue?vue&type=style&index=0&id=e12090d6&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12090d6",
  null
  
)

export default component.exports